
  // Export
  module.exports =
  {

    // Search scripts
    search:
    {

      // Method-wide scripts
      _init: function ()
      {
        APPLICATION._APPLICATION.load($('#applications'), APPLICATION._PATH_PREFIX + 'visits/applications', 'Visits', 'applications')      
      }

    },

    // Applications scripts
    applications:
    {

      // Method-wide scripts
      _init: function ()
      {
        APPLICATION._APPLICATION.processLinks('#applications', 'Visits', 'applications')
      }

    },

    // Edit site visit scripts
    editSiteVisit:
    {

      // Method-wide scripts
      _init: function ()
      {
  
        // On clicking the calendar
        $('#site_visit_calendar').not('.js-ignore').click(function ()
        {
  
          // Get the form
          var form = $(this).closest('form').serialize()
  
          // Get the development ID
          var development_id = $(this).closest('form').attr('data-' + APPLICATION._DATA_PREFIX + 'development_id')

          // Get the input
          var input = $(this).attr('for')
  
          // Store the datepicker
          APPLICATION._datepicker = function (date)
          {
  
            // Set the due date
            form += '&site_visit_date=' + date
  
            // Show the custom modal
            APPLICATION._APPLICATION.customModal(APPLICATION._PATH_PREFIX + 'visits/edit-site-visit/' + development_id + '?' + form, 'Visits', 'editSiteVisit')
  
          }
  
          // Get the parts
          var parts = $('#' + input).val().split('/')
  
          // Open the calendar
          APPLICATION._APPLICATION.customModal(APPLICATION._PATH_PREFIX + 'calendar/month/' + parts[2] + '/' + parts[1] + '?modal=1&date=' + parts[2] + '-' + parts[1] + '-' + parts[0], 'Calendar', 'month')  

        }
        ).addClass('js-ignore')

      }

    }

  }